import { render, staticRenderFns } from "./KeywordChip.vue?vue&type=template&id=24db7ff8&scoped=true&"
import script from "./KeywordChip.vue?vue&type=script&lang=js&"
export * from "./KeywordChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24db7ff8",
  null
  
)

export default component.exports